'use strict';

/**
 * @ngdoc function
 * @name thothApp.services:ScopeChangeRequest
 * @description
 * # ScopeChangeRequest
 * Service to contact scope change requests API
 */
angular.module('thothApp.services')
  .factory('ScopeChangeRequest', ['$http', 'domain', 'BaseService', function ($http, domain, BaseService) {
    var BASE_URL = domain.name + '/api/v1/scope_change_requests/';
    var baseService = new BaseService();

    baseService.initialize({
      baseUrl: BASE_URL,
      baseModelName: 'scope_change_request'
    });

    baseService.approve = function(id) {
      return $http.post(BASE_URL + id + '/approve');
    };

    baseService.reject = function(id, comment) {
      return $http.post(BASE_URL + id + '/reject', { review_comment: comment });
    };

    baseService.error = function(error) {
      baseService.baseError(error);
    };

    return baseService;
  }]);
